import { EyeOff } from "lucide-react";
import { useAuth } from "@/auth/AuthContext";
import { canToggleHideTax } from "@/lib/hideTax";

/** Who may flip "hide tax" on a customer or a document. */
export function useCanHideTax() {
  const { user } = useAuth();
  return canToggleHideTax(user?.role);
}

/**
 * Internal-only badge (iter310). The customer's copy shows no tax line —
 * this tells our own people where the money went. Never rendered on a
 * customer-facing PDF, email or public review page.
 */
export const TaxHiddenBadge = ({ taxAmount = 0, taxRate = 0, testId = "tax-hidden-badge", className = "" }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1 rounded-full border border-amber-300 bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-800 ${className}`}
    title="The customer's documents show no tax line. Tax is still calculated, charged and remitted."
  >
    <EyeOff className="w-3 h-3" />
    Tax hidden — {Number(taxAmount || 0).toLocaleString("en-US", { style: "currency", currency: "USD" })} included in material
    {taxRate ? ` (${taxRate}%)` : ""}
  </span>
);

export default TaxHiddenBadge;
